import React from 'react';
import cn from 'classnames';
import { Modal } from 'react-bootstrap';
import { useBoolean } from 'react-use';
import T from 'prop-types';
import { Button } from '../../../../components/button';
import { Chip } from '../../../../components/chip/Chip';
import { Control } from '../../../../components/form';
import { OCCUPATION } from '../../../../constants/occupation';
import text from '../../../../text';
import { onboardingConstants } from './constants';
import { useOnboarding } from './reducer';

const Profession = ({ onSubmit, submitButtonText }) => {
  const [{ profession, fullName, phoneNumber, isMarketingEnabled }, dispatch] =
    useOnboarding();
  const [hasOther, setHasOther] = useBoolean(false);
  const [loading, setLoading] = useBoolean(false);
  const disabled = !profession || loading;

  const handleSubmit = async () => {
    setLoading(true);
    await onSubmit({ profession, fullName, phoneNumber, isMarketingEnabled });
    setLoading(false);
  };

  const onClick = () => {
    handleSubmit();
  };

  const onToggleProfession = (payload, other) => {
    setHasOther(other);

    dispatch({
      type: onboardingConstants.TOGGLE_PROFESSION,
      payload,
    });
  };

  const onClickOther = () => onToggleProfession('');

  const handleChange = (e) =>
    dispatch({
      type: onboardingConstants.TOGGLE_PROFESSION,
      payload: e.target.value,
    });

  return (
    <>
      <Modal.Header>
        <div className='d-flex flex-column align-items-center flex-fill'>
          <h2 className='text-center w-100 font-24 mb-2'>
            {text('enterOccupation')}
          </h2>
          <p className='text-center font-16'>{text('selectKeyRole')}:</p>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div
          className={cn(
            'd-flex flex-row align-items-center justify-content-center pt-2 flex-wrap flex-gap-8',
            {
              'pb-4': hasOther,
              'pb-5': !hasOther,
            }
          )}
        >
          {Object.values(OCCUPATION).map((occupation) => (
            <Chip
              key={occupation}
              label={occupation}
              onSelect={() =>
                OCCUPATION.OTHER === occupation
                  ? onClickOther()
                  : onToggleProfession(occupation, false)
              }
              active={
                profession === occupation ||
                (hasOther && occupation === OCCUPATION.OTHER)
              }
            />
          ))}
        </div>

        {hasOther ? (
          <div
            className={cn('px-4', {
              'pb-4': !hasOther,
            })}
          >
            <p className='mb-1 font-14 font-weight--600'>
              {text('otherOccupation')}
            </p>
            <Control
              as='input'
              type='text'
              name='profession'
              value={profession || ''}
              onChange={(e) => handleChange(e)}
              placeholder={text('enterOccupation')}
              autoComplete='off'
              className='mt-0'
            />
          </div>
        ) : null}

        <Button
          disabled={disabled}
          onClick={onClick}
          className='btn-block mt-4 w-100'
          loading={loading}
        >
          {submitButtonText}
        </Button>
      </Modal.Body>
    </>
  );
};

Profession.propTypes = {
  onSubmit: T.func.isRequired,
  submitButtonText: T.string,
};

export default Profession;
